import { Navigate, useLocation } from 'react-router-dom';
import Spinner from 'src/views/spinner/Spinner';
import useAuth from './UseAuth';
import { useState } from 'react';
// import { useEffect } from 'react';

const RoleGuard = ({ children, allowedRoles }: any) => {
  const { isAuthenticated, isInitialized, role } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!isInitialized) {
    return <Spinner />;
  }
  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }

    return <Navigate to={`/auth/${role}/login`} replace={true} />;
  }
  if (!isUserAllowed(role, allowedRoles)) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }

    return <Navigate to={`/auth/${role}/login`} replace={true} />;
  }
  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);

    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};
const isUserAllowed = (user: string, allowedRoles: string) => {
  return user === allowedRoles;
};

export default RoleGuard;
